(function () {
	'use strict';
	$(document).ready(function () {

		new Swiper('.homepage .swiper-top', {
			slidesPerView: 1,
			spaceBetween: 0,
			autoplay: {
			delay: 5000
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
		})

		new Swiper('.homepage .swiper-posts', {
			//autoHeight: true,
			slidesPerView: 1,
			spaceBetween: 15,
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			breakpoints: {
				767: {
					slidesPerView: 2
				},
				990: {
					slidesPerView: 3
				},
			},
		});

	});
}(jQuery));
